import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormLabel,
  Select,
  Spinner,
  Text,
} from '@chakra-ui/react';
import { createAPIEndPoint } from 'config/api/api';

const ModelSelect = ({ formik, serviceType }) => {
  const [modelOptions, setModelOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchModels = async () => {
    if (!serviceType) return;
    // setLoading(true);

    try {
      const res = await createAPIEndPoint(`model?service=${serviceType}`).fetchAll();
      const models = res.data || [];

      const formatted = models.map((m) => ({
        label: m.model,
        value: m.model,
        full: m, // Store the full model object for later access
      }));

      setModelOptions(formatted);

      // Auto-select first model if current is invalid
      const current = formik.values.model;
      const match = formatted.find((m) => m.value === current);
      if (!match && formatted.length > 0) {
        formik.setFieldValue('model', formatted[0].value);
        if (serviceType === 'deepgram') {
          formik.setFieldValue('listen', formatted[0].full.listen || '');
          formik.setFieldValue('speak', formatted[0].full.speak || '');
        }
      }
    } catch (err) {
      console.error('❌ Failed to fetch models:', err);
      setModelOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModels();
  }, [serviceType]);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    formik.setFieldValue('model', selectedValue);

    if (serviceType === 'deepgram') {
      const selected = modelOptions.find((m) => m.value === selectedValue);
      if (selected) {
        formik.setFieldValue('listen', selected.full.listen || '');
        formik.setFieldValue('speak', selected.full.speak || '');
      }
    }
  };

  return (
    <FormControl isInvalid={formik.touched.model && formik.errors.model} mb={3}>
      <FormLabel>Model</FormLabel>
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <Select
          name="model"
          placeholder={`Select a ${serviceType} model`}
          value={formik.values.model}
          onChange={handleChange}
          onBlur={formik.handleBlur}
          fontSize="sm"
          fontWeight="500"
          variant="auth"
        >
          {modelOptions.map((model) => (
            <option key={model.value} value={model.value}>
              {model.label}
            </option>
          ))}
        </Select>
      )}
      {formik.touched.model && formik.errors.model && (
        <Text color="red.500" fontSize="sm">
          {formik.errors.model}
        </Text>
      )}
    </FormControl>
  );
};

export default ModelSelect;
